import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 0C4.44 0-1.167 7.014.498 14.389l.535 2.369 1.48 4.809a3 3 0 0 0 3.455 2.06l.751-.151 2.961-.74-1.93-9.005-5.01 1.503-.291-1.286C1.066 7.825 5.722 2 12 2c6.278 0 10.934 5.825 9.551 11.948l-.29 1.286-5.012-1.503-1.93 9.005 2.961.74.752.15a3 3 0 0 0 3.455-2.06l1.48-4.808.535-2.37C25.167 7.015 19.56 0 12 0ZM4.424 20.979l-1.172-3.81 2.997-.9 1.07 4.995-1.038.26-.705.141a1 1 0 0 1-1.152-.686Zm15.152 0 1.172-3.81-2.997-.9-1.07 4.995 1.038.26.705.141a1 1 0 0 0 1.152-.686Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionHeadphones24 = createIcon(IconComponent);